
<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  
                </div>
            </div>
            <div class="personal-details">
                <!-- <h4 class="personal-details-title">Change Password</h4> -->

                
                <div [formGroup]="form">
                    <div class="form-group">
                        <label>{{ 'users.oldPassword' | translate }}</label>
                        <input formControlName="password" type="password" class="form-control">
                        <span class="err" *ngIf="form.get('password').invalid && formSubmit">old password required</span>
                    </div>
                    <div class="form-group">
                        <label>{{ 'users.newPassword' | translate }}</label>
                        <input formControlName="newPassword" type="password" class="form-control">
                        <span class="err" *ngIf="form.get('newPassword').invalid && formSubmit">new password required</span>
                    </div>
                    <div class="form-group">
                        <label>{{ 'users.conformNewPassword' | translate }}</label>
                        <input formControlName="confirmPassword" type="password" class="form-control">
                        <span class="err" *ngIf="form.get('confirmPassword').invalid && formSubmit">confirm password required</span>
                    </div>
                    <div class="form-group">
                        <button (click)="ChangePassword()" class="btn btn-primary">{{ 'users.changePassword' | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>